import { CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import CONSTANTS, { PAGES_ROUTES } from '../Constants'
import { API_CONFIG, API_LIST } from '../Constants/ApiDefinations'
import { getLocalStorage, setLocalStorage } from '../Helpers/Storage'
import mainApiService from '../Services'
import { useAppDispatch } from '../Store/Hooks'
import { getAppConfig, getAppConfigSettings } from '../Store/Slice/appConfig.slice'

const ConfigLoader = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadeConfig()
  }, [])

  const loadeConfig = async () => {
    const configRes = await Promise.all([
      dispatch(getAppConfig() as any),
      dispatch(
        getAppConfigSettings({
          settings: ['buildConfig', 'cmsConfig', 'multiAudioConfig', 'managePolicyConfig'],
        }) as any,
      ),
    ])
    if (configRes?.[0]?.payload?.responseCode === 200) {
      await updateNotificationsReadStatus()
      setLocalStorage(
        'refresh_token',
        configRes?.[1]?.payload?.data?.cmsConfig?.ENABLED_FEATURES?.REFRESH_TOKEN || false,
      )
      setLoading(false)
    }
  }

  const updateNotificationsReadStatus = async () => {
    const unReadNotifIds = getLocalStorage(CONSTANTS.LOCAL_KEYS.UNREAD_NOTIF_IDS)
    if (unReadNotifIds.length > 0) {
      const requestedData: any = API_CONFIG(API_LIST.NOTIFICATIONS.MARK_AS_READ, {
        isRead: true,
        notificationIds: unReadNotifIds,
      })
      if (location.pathname.includes(PAGES_ROUTES.AllNotificationsPage)) {
        await mainApiService(requestedData)
      } else {
        mainApiService(requestedData)
      }
    }
    setLocalStorage(CONSTANTS.LOCAL_KEYS.UNREAD_NOTIF_IDS, [])
    return true
  }

  if (loading)
    return (
      <div
        data-testid='Loading configuration...'
        style={{ textAlign: 'center', marginTop: '20vh', height: '50px' }}
      >
        <CircularProgress variant='indeterminate' />
      </div>
    )

  return <>{children}</>
}

export default ConfigLoader
